import React from "react";
import { fieldTypeIcons } from "../../registry/fieldTypeIcons";
import { IconSlot } from "./FieldTypeIcon.styles";
import type { FieldTypeIconProps } from "./FieldTypeIcon.types";

/** Coloured field-type glyph. Decorative: the field's label carries the meaning. */
export const FieldTypeIcon: React.FC<FieldTypeIconProps> = ({
  kind,
  size = 16,
  testId,
  className,
}) => {
  const { Icon, color } = fieldTypeIcons[kind];
  return (
    <IconSlot
      $color={color}
      $size={size}
      aria-hidden
      data-testid={testId ?? `field-type-icon-${kind}`}
      className={className}
    >
      <Icon size={size} />
    </IconSlot>
  );
};

export default FieldTypeIcon;
